<template>
    <!-- View Reminder Modal -->
    <div class="modal fade" id="viewReminderModal" ref="viewReminderModal" tabindex="-1" aria-labelledby="reminderModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 900px;">
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="reminderModalLabel">
                        View Reminder <template v-if="quotation"> for {{quotation.name}}</template>
                    </h5>
                    <button type="button" class="btn-close"  data-dismiss="modal" aria-label="Close">&times;</button>
                </div>
                <div class="modal-body" v-if="reminder">

                    <div class="alert alert-success" role="alert" v-if="successMessage">
                        {{ successMessage }}
                    </div>

                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="javascript:void(0);" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <div class="row" v-if="!quotation && reminder && reminder.order">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label">Sales Order: </label>
                                <template v-if="reminder && reminder.order">#{{reminder.order.order_number}}</template>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="!quotation && reminder && reminder.purchase_order">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label">Purchase Order: </label>
                                <template v-if="reminder && reminder.purchase_order">#{{reminder.purchase_order.po_number}}</template>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="!quotation && reminder && reminder.customer">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label">Customer: </label> {{reminder.customer.company_name}}
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="!quotation && reminder && reminder.vendor">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label">Vendor: </label> {{reminder.vendor.company_name}}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label">Title: </label> {{reminder.title}}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="form-label">Description</label>
                            <p v-html="reminder.details"></p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="mt-3">
                                <label class="form-label">Due Date: </label> {{formatDate(reminder.due_date)}}
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="mt-3">
                                <label class="form-label">Due Time: </label> <template v-if="reminder.due_time">{{reminder.due_time}}</template><template v-else>All Day</template>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="mt-3">
                                <label class="form-label">Assign To: </label>
                                <template v-for="admin in reminder.admins">{{admin.name}},</template>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="mt-3">
                                <label class="form-label">Priority: </label>
                                <template v-if="reminder.priority">{{reminder.priority.priority_name}}</template>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="mt-3">
                                <label class="form-label">Status: </label>
                                <template v-if="reminder.status == 0">Open</template>
                                <template v-if="reminder.status == 1">Closed</template>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3 text-end">
                        <button type="button" :disabled="loading" @click="editReminder" class="btn btn-primary fw-semibold fs-14 px-4">Edit</button>
                        <button v-if="reminder.status == 0" type="button" :disabled="loading" @click="completeReminder" class="btn btn-primary fw-semibold fs-14 px-4">Complete</button>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from "axios";

export default {
    name: "ViewReminder",
    props:['reminder', 'loading', 'quotation'],
    components:{},
    created() {
    },
    mounted() {

    },
    data(){
        return {
        };
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        editReminder() {
            this.$emit('openEditEvent', this.reminder);
        },
        completeReminder() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.post(window.route('dashboard.reminders.complete', {id: this.reminder.id}), {},{

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && Object.keys(data.errors).length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.reminder.status = 1;
                        self.setSuccessMessage(data.data);
                        this.$emit('reminderCompletedEvent', this.reminder);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    },
    watch: {
    }
}
</script>

<style scoped>

</style>
